const CapTableFragment = `
    id
    amount
`

export default CapTableFragment
